export default __webpack_public_path__ + "static/media/auto_matching.5de73fe0.svg";